// extracted by mini-css-extract-plugin
export default {"icon":"MyCoursesTab_icon__NcRMn"};